import { useEffect } from "react";
import "./App.css";
import Experience from "./components/Experience";
import Home from "./components/Home";
import Navbar from "./components/Navbar";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Footer from "./components/Footer";
import FAQ from "./components/FAQ";
import Aos from "aos";
import 'aos/dist/aos.css';
import ContactUs from "./components/ContactUs";

function App() {

  useEffect( () => { Aos.init() } , [] )

  return (
   <>
      <div className="w-[1200px] flex flex-col justify-center items-center">
        <Navbar />
        <Home />
        <Skills />
        <Projects />
        <Experience />
        <FAQ />
        <ContactUs />
        <Footer />
      </div>
   </>
  )
}

export default App;
